var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDbHarvest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#0FDFDF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8074 22.1201L24.0018 28.5087L14.1963 22.1201L12.0039 23.2613L24.0018 31.048L35.9998 23.2613L33.8074 22.1201Z",
    fill: "#0FDFDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8074 26.3369L24.0018 32.7255L14.1963 26.3369L12.0039 27.4781L24.0018 35.2648L35.9998 27.4781L33.8074 26.3369Z",
    fill: "#0FDFDF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2732 15.2012L17.0898 16.3625L20.4592 18.5427L22.5829 17.25L19.2732 15.2012Z",
    fill: "#0FDFDF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4369 20.2021L17.0176 22.2835L19.3784 23.8217L22.7046 21.6694L20.4369 20.2021Z",
    fill: "#0FDFDF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.923 18.0791L21.7695 19.3899L23.9976 20.8316L26.1351 19.4485L23.923 18.0791Z",
    fill: "#0FDFDF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4571 20.2676L25.291 21.6691L28.6175 23.8215L30.8492 22.3673L27.4571 20.2676Z",
    fill: "#0FDFDF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6846 15.1807L25.2695 17.2593L27.4409 18.6035L30.9053 16.3619L28.6846 15.1807Z",
    fill: "#0FDFDF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9986 22.5059L20.668 24.661L23.9988 26.8313L27.3295 24.6611L23.9986 22.5059Z",
    fill: "#0FDFDF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6699 17.1182L12 19.0453L15.7113 21.4329L19.126 19.3544L15.6699 17.1182Z",
    fill: "#0FDFDF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9971 12.7344L20.709 14.4369L23.9288 16.4301L27.2415 14.4136L23.9971 12.7344Z",
    fill: "#0FDFDF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3258 17.1172L28.7637 19.4221L32.151 21.5191L35.996 19.0445L32.3258 17.1172Z",
    fill: "#0FDFDF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDbHarvest);
export default __webpack_public_path__ + "static/media/icon-db-harvest.f8d8a707fb7216674eb47ff050499aa9.svg";
export { ForwardRef as ReactComponent };